import { FlexContainer } from "@mindmemobile/mm-shared-global";
import React, { Component } from "react";
import { MediaModel } from "../../../shared/models";
import { ItemFrame, ItemImage } from "../../../shared/styles";

type IProps = {
  medias: MediaModel[];
};
export default class ItemMediaSection extends Component<IProps> {
  render() {
    if (!this.props.medias || this.props.medias.length === 0) return null;

    const images = this.props.medias.filter((m) => m.type === "Image");

    if (images.length === 0) return null;

    return (
      <FlexContainer spacing={20}>
        <ItemFrame className="variant-readonly-frame">
          <FlexContainer spacing={30} fxWrap="wrap">
            {images.map((m, idx) => (
              <ItemImage
                className="uploaded-image multiple-media-variant"
                key={idx}
              >
                <div>
                  <img src={m.fullURL} className="product-image" />
                </div>
              </ItemImage>
            ))}
          </FlexContainer>
        </ItemFrame>
      </FlexContainer>
    );
  }
}
